import { DropdownTrigger } from '@fiverr-private/dropdown';

export default DropdownTrigger;
